import { Button } from '@kalos/ui';
import { MagnifyingGlassIcon, PersonIcon } from '@radix-ui/react-icons';
import { Link } from '@tanstack/react-router';
import { type FC } from 'react';

interface JobNotFoundProps {
  jobNumber: number;
}

export const JobNotFound: FC<JobNotFoundProps> = ({ jobNumber }) => {
  return (
    <div className="flex min-h-[50vh] flex-col items-center justify-center gap-6 p-8">
      <div className="flex flex-col items-center gap-4 text-center">
        <div className="flex h-20 w-20 items-center justify-center rounded-full bg-red-100">
          <MagnifyingGlassIcon className="h-10 w-10 text-red-600" />
        </div>
        <div className="space-y-2">
          <h1 className="text-3xl font-bold text-gray-900">Job Not Found</h1>
          <p className="text-lg text-gray-600">
            We couldn&apos;t find a job with the number{' '}
            <span className="font-semibold text-gray-900">{jobNumber}</span> in our database.
          </p>
        </div>
      </div>

      <div className="flex flex-col gap-4 sm:flex-row">
        <Button asChild size="lg" className="flex items-center gap-2">
          <Link to="/jobs">
            <MagnifyingGlassIcon className="h-5 w-5" />
            Search Jobs
          </Link>
        </Button>
        <Button asChild variant="outline" size="lg" className="flex items-center gap-2">
          <Link to="/customers">
            <PersonIcon className="h-5 w-5" />
            Search Customers
          </Link>
        </Button>
      </div>

      <div className="mt-8 max-w-md text-center text-sm text-gray-500">
        <p>
          The job number you&apos;re looking for might have been archived, deleted, or entered
          incorrectly. Try searching for jobs or customers to find what you&apos;re looking for.
        </p>
      </div>
    </div>
  );
};
